const canUseLocalStorage = (() => {
  try {
    window.localStorage.getItem('anything');
    return true;
  } catch (e) {
    return false;
  }
})();

export default canUseLocalStorage;
